export const EIP1271_ABI = [
  'function isValidSignature(bytes32 _message, bytes _signature) public view returns (bool)'
];
